import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
} from "@material-ui/core";
import GoalReview from "@material-ui/icons/Adjust";
import Setup from "@material-ui/icons/AssignmentTurnedIn";
import Bookmark from "@material-ui/icons/Bookmark";
import AcademicPlans from "@material-ui/icons/BorderColor";
import Staff from "@material-ui/icons/Group";
import MyClasses from "@material-ui/icons/MenuBook";
import SettingsIcon from "@material-ui/icons/Settings";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import withTabsPrivilege from "common/hocs/withTabsPrivilege";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { clearPageFilters } from "state/slices/globalFormSlice";
import { getAllowedTabs } from "../sideDrawer/util";

const useStyles = makeStyles((theme) => ({
  inputFormControl: {
    width: "100%",
    marginBottom: "1rem",
  },
  flexGrid: {
    "&.MuiGrid-root": {
      display: "flex",
    },
  },
  container: {
    height: "100%",
    maxWidth: "100%",
    marginTop: "3rem",
    marginBottom: "1rem",
  },
  tabsBtn: {
    background: "#898eac2e",
    borderRadius: 6,
  },
  dashCards: {
    backgroundSize: "cover",
    backgroundPositionY: "center",
    border: "1px solid #cacaca",
  },
  configCards: {
    height: "150px",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  cardContent: {
    height: "100%",
    display: "flex",
    flexDirection: "coluasfdfmn",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitle: {
    textAlign: "center",
  },
  cardIcon: {
    height: "auto",
  },
  disabled: {
    backgroundSize: "cover",
    backgroundPositionY: "center",
    borderRadius: "10px",
    backgroundColor: "#dadada",
    cursor: "not-allowed",
    color: "grey",
    display: "none",
  },
  disabledConfig: {
    height: "150px",
    borderRadius: "10px",
    cursor: "not-allowed",
    backgroundColor: "#a8a8a8",
  },
}));

const configCards = [
  {
    id: "school",
    icon: <SettingsIcon />,
    title: "School Setup",
    width: "40px",
    route: "/schools",
    disabled: false,
  },
  {
    id: "teacher",
    icon: <Staff />,
    title: "Staff",
    width: "50px",
    route: "/users",
    disabled: false,
  },
];

const dashCards = [
  {
    id: "class",
    icon: <MyClasses />,
    title: "My Classes",
    width: "50px",
    route: "/master-data/classes",
    disabled: true,
  },
  {
    id: "annualplan",
    icon: <AcademicPlans />,
    title: "Academic Plans",
    width: "50px",
    route: "/annual-plans",
    disabled: false,
  },
  {
    id: "goalsettingform",
    icon: <Setup />,
    title: "Goals Setup",
    width: "50px",
    route: "/goals/set",
    disabled: false,
  },
  {
    id: "goalsettingreview",
    icon: <GoalReview />,
    title: "Goals Review",
    width: "50px",
    route: "/goals/set/review",
    disabled: false,
  },
  {
    id: "",
    icon: <Bookmark />,
    title: "View Bookmarks",
    width: "50px",
    route: "/dashboard",
    disabled: true,
  },
];

const Dashboard = ({ tabAccess }) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearPageFilters());
  }, [dispatch]);

  const combinedClasses = clsx(classes.configCards, classes.dashCards);

  return (
    <Container className={classes.container}>
      <Box style={{ marginBottom: "5rem" }}>
        <h2>Dashboard Overview</h2>
        <Grid container spacing={4}>
          {getAllowedTabs(tabAccess, dashCards).map((card) => (
            <Grid
              item
              key={card.id}
              xs={12}
              sm={4}
              md={3}
              style={card.disabled ? { display: "none" } : { display: "block" }}
            >
              <Link to={card.route}>
                <Card
                  className={card.disabled ? classes.disabled : combinedClasses}
                  style={{ height: "95px", display: "flex" }}
                  elevation="none"
                  disabled={card.disabled}
                >
                  <CardMedia
                    style={{
                      backgroundColor: "#E3D5CA",
                      padding: "0 0.8rem",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <IconButton
                      aria-label="card icons"
                      style={{ color: "#263657" }}
                    >
                      {card.icon}
                    </IconButton>
                  </CardMedia>

                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <CardContent style={{ flex: "1 0 auto" }}>
                      <h3 style={{ fontWeight: "normal" }}>{card.title}</h3>
                    </CardContent>
                  </Box>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box>
        {configCards.map.length !== 0 && <h2>School Wide Configuration</h2>}
        <Box>
          <Grid container spacing={4}>
            {getAllowedTabs(tabAccess, configCards).map((card) => (
              <Grid
                item
                key={card.id}
                xs={12}
                sm={4}
                md={3}
                style={
                  card.disabled ? { display: "none" } : { display: "block" }
                }
              >
                <Link to={card.route}>
                  <Card
                    className={
                      card.disabled ? classes.disabled : combinedClasses
                    }
                    style={{
                      height: "95px",
                      display: "flex",
                      borderLeft: "5px solid #263657",
                    }}
                    elevation="none"
                    disabled={card.disabled}
                  >
                    <CardMedia
                      style={{
                        padding: "0 0.8rem",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <IconButton
                        aria-label="card icons"
                        style={{
                          color: "#263657",
                          backgroundColor: "#E3D5CA",
                          borderRadius: "4px",
                        }}
                      >
                        {card.icon}
                      </IconButton>
                    </CardMedia>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <CardContent style={{ flex: "1 0 auto" }}>
                        <h3 style={{ fontWeight: "normal" }}>{card.title}</h3>
                      </CardContent>
                    </Box>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default withTabsPrivilege(Dashboard);
